export const SiteTypesInfo = {
  TRANSPORT: '运输站点',
  TRANSPORT_WAREHOUSE: '仓库站点',
  TRANSFER: '中转站点',
};
export const SitetSationType = {
  0: '取货点',
  1: '送货点',
  2: '取货点+送货点',
};

export const SiteStatus = {
  ENABLED: '启用',
  DISABLED: '停用',
};

export const SiteCommercialtype = {
  0: '仓库',
  1: '专线',
  2: '商超',
  3: '工厂',
  4: '配送门店',
};

export const stationCategory = {
  1: '市区',
  2: '郊县',
  3: '外阜',
  4: '统配',
  5: '经销商',
};

// table表单字段
export const fields = [

  {
    prop: 'stationName',
    width: '80',
    label: '站点名称',
  },
  {
    prop: 'stationCode',
    width: '180',
    label: '站点编号',
  },
  {
    prop: 'bizType',
    width: '120',
    label: '站点类型',
  },
  {
    prop: 'type',
    width: '120',
    label: '业态类型',
  },
  {
    prop: 'tenantName',
    width: '240',
    label: '租户名称',
  },
  {
    prop: 'customerName',
    width: '240',
    label: '客户名称',
  },
  {
    prop: 'positionInfo',
    width: '240',
    label: '位置',
  },
  {
    prop: 'address',
    width: '240',
    label: '详细地址',
  },
  {
    prop: 'status',
    width: '80',
    label: '状态',
  },
  {
    prop: 'contacts',
    width: '80',
    label: '联系人',
  },
  {
    prop: 'telPhone',
    width: '130',
    label: '联系电话',
  },
  {
    prop: 'createTime',
    width: '160',
    label: '创建时间',
  },
  {
    fixed: 'right',
    prop: 'action',
    width: '200',
    label: '操作',
    isComponent: true,
  },
];
